// extracted by mini-css-extract-plugin
export default {"dialogList":"delete-subscription-modal_dialogList__3K0oY"};